<template>
  <div class="playback-speed-button">
    <div class="tooltip">
      <span
        class="material-icons speed-icon"
        :style="iconStyleObject"
        @click="onClick"
        @mouseover="onMouseover"
        @mouseleave="onMouseleave"
        >speed</span
      >
      <span class="description-top" v-show="isShow">
        <vue-slider
          ref="rgPlaybackSlider"
          v-model="value"
          direction="btt"
          :height="120"
          :min="min"
          :max="max"
          :interval="1"
          :tooltip="tooltip"
          :process-style="processStyle"
          @change="onChange"
        >
        </vue-slider>
      </span>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";

export default {
  name: "PlaybackSpeedButton",
  components: { VueSlider },
  data() {
    return {
      max: 240,
      min: 1,
      tooltip: "none",
      value: 60,
      isShow: false,
      processStyle: {
        border: "2px solid #4D9EF2",
      },
      iconStyleObject: {
        color: "#F2F2F2",
      },
    };
  },
  methods: {
    onChange() {
      this.$emit("updatePlaybackSpeed", this.value / 60);
    },
    onClick() {
      this.isShow = !this.isShow;
    },
    onMouseover() {
      if (!this.isShow) {
        this.iconStyleObject.color = "#4D9EF2";
      }
    },
    onMouseleave() {
      if (!this.isShow) {
        this.iconStyleObject.color = "#F2F2F2";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.playback-speed-button {
  .tooltip {
    position: relative;
    cursor: pointer;
    padding: 0 5px;
    font-size: 0.9em;
    display: inline-block;
  }

  .speed-icon {
    font-size: 48px;
  }

  .description-top {
    position: absolute;
    padding: 10px;
    font-size: 12px;
    line-height: 1.6em;
    color: $aisea-white;
    border-radius: 5px;
    background: #000;
    width: 40px;
    display: inline-block;
    visibility: visible;
    top: -150px;
    left: 9px;
    opacity: 1;
  }
}
</style>
